// @flow
import React from 'react';

import { I18n } from '@lingui/react';
import TextInput, { type Props as TextInputProps } from '../TextInput';

export type Props = TextInputProps;

export default (props: Props) => (
  <I18n>
    {({ i18n }) => (
      <TextInput
        name="city"
        placeholder={i18n._('City')}
        autoComplete="address-level2"
        {...props}
      />
    )}
  </I18n>
);



// WEBPACK FOOTER //
// ../react-lib/src/components/formFields/CityInput/CityInput.jsx